import { Button } from 'antd';
import ReportingPage from './reporting-page';
import { TeamReportingPage } from './team-reporting-page';
import { Header } from '../header/header';
import { useState } from 'react';
import { SwapOutlined } from '@ant-design/icons';
import { strings } from '../../lang';

const ReportingPageWithTabs = () => {
  const [individualView, setIndividualView] = useState<boolean>(true);
  return (
    <>
      <Header
        centerComponents={
          <Button type="primary" onClick={() => setIndividualView(!individualView)}>
            <SwapOutlined />
            {individualView ? strings.reporting.viewSwitch.teamView : strings.reporting.viewSwitch.individualView}
          </Button>
        }
      />
      {individualView ? <ReportingPage hideHeader={true} /> : <TeamReportingPage />}
    </>
  );
};

export default ReportingPageWithTabs;
